import clsx from 'clsx';
import { isMobileChannel } from '../../../../common/util';
import i18n from '../../../../common/i18n';
import React from 'react';

const KycFormExpandedHeader = ({ postfix }: { postfix?: string }) => (
    <>
        <div
            className={clsx('text-extra-bold', {
                'fs-16': isMobileChannel(),
                'fs-18': !isMobileChannel()
            })}
        >
            {i18n('nui.kyc.announcement.title' + (postfix ?? ''))}
        </div>
        <div className="mt-10 fs-14 nui-homepage-kyc-announcement">
            <span className="pr-3">{i18n('nui.kyc.announcement.description.one' + (postfix ?? ''))}</span>
            <span className="pr-3 text-extra-bold">{i18n('nui.kyc.announcement.description.two')}</span>
            <span>{i18n('nui.kyc.announcement.description.three')}</span>
        </div>
    </>
);

export default KycFormExpandedHeader;
